<template>
    <div class="field-wrap field-datepicker">
        <label v-if="label || required" class="field-datepicker__label">
            {{ label }}<span v-if="required" class="field-datepicker__label-required">&nbsp;*</span>
        </label>

        <datepicker
            :value="getDate"
            @input="setDate"
            :language="de"
            format="dd.MM.yyyy"
            :clear-button="true"
            placeholder="Datum eingeben"
            :full-month-name="true"
        ></datepicker>
    </div>
</template>

<script>
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
import Datepicker from 'vuejs-datepicker';
import { de } from 'vuejs-datepicker/dist/locale';

export default {
    data() {
        return {
            de: de
        };
    },
    components: {
        Datepicker
    },
    methods: {
        setDate(d) {
            if (d !== null && d !== '') {
                d =
                    d.getFullYear() +
                    '-' +
                    ('0' + (d.getMonth() + 1)).slice(-2) +
                    '-' +
                    ('0' + d.getDate()).slice(-2);
            }
            this.simpleFieldSet(d);
        }
    },
    computed: {
        getDate() {
            let d = this.simpleFieldGet;
            if (d !== undefined && d !== null && d !== '') {
                d = new Date(d);
            }
            return d;
        }
    },
    mixins: [SimpleFieldMixin],
    props: {}
};
</script>
